import { mapState } from "vuex";

import formable from "@/mixins/formable";

export default {
  mixins: [
    formable
  ],
  data() {
    return {
      form: {
        cleaning_type: 2,
        status: 1,
        steps: [{}],
        reservation_id: null,
        unit_id: null,
      },
      userOptions: {
        filters: {}
      },
    };
  },
  beforeMount() {
    this.userOptions = {
      filters: {
        roles: [
          this.$const('ConstRoles', 'CLEANING_SERVICE')
        ]
      }
    }
  },
  methods: {
    addStep() {
      this.form.steps.push({
        description: null,
        time: null
      });
      this.$forceUpdate();
    },
    removeStep(index) {
      this.form.steps.splice(index, 1);
      this.$forceUpdate();
    },
  },
  computed: {
    initialized() {
      return !this.itemRequest.loading;
    },
    ...mapState({
      itemRequest: state => state.housekeepingTasks.getSingleRequest,
    })
  }
};
